/**
 * Baut die Staffelpreis-Tabelle aus #dr-DiscountElement (.dr-discountInfoTable)
 * Endpreis = Varianten-Grundpreis (cent) − Rabatt aus der App (pro Stück).
 */
(function () {
  const SELECTORS = {
    appRoot: '#dr-DiscountElement',
    appTable: 'table.dr-discountInfoTable tbody tr, .pricetable table tbody tr',
    qty: '.dr-discountInfoTableTdQuantityValue',
    discount: '.dr-discountInfoTableTdDiscountValue',
  };

  function parseEuMoneyToCents(text) {
    if (!text || typeof text !== 'string') return 0;
    const t = text.trim();
    const decMatch = t.match(/(\d+)[.,](\d{2})\b/);
    if (decMatch) {
      return parseInt(decMatch[1], 10) * 100 + parseInt(decMatch[2], 10);
    }
    const intMatch = t.match(/(\d+)/);
    return intMatch ? parseInt(intMatch[1], 10) * 100 : 0;
  }

  function formatMoneyCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents);
      } catch (e) {
        /* fallback */
      }
    }
    const n = (Number(cents) || 0) / 100;
    return n.toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function getVariantPricesFromBlock(root) {
    const el = root.querySelector('script[data-bulk-price-variant-prices]');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function getCurrentVariantId(sectionId) {
    const form = document.getElementById('product-form-' + sectionId);
    const input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    const any = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return any && any.value ? String(any.value) : null;
  }

  function getBasePriceCents(sectionId, variantPrices) {
    const vid = getCurrentVariantId(sectionId);
    if (vid && variantPrices[vid] != null) return Number(variantPrices[vid]);
    const first = Object.values(variantPrices)[0];
    return first != null ? Number(first) : 0;
  }

  function parseAppTiers() {
    const root = document.querySelector(SELECTORS.appRoot);
    if (!root) return [];
    const rows = root.querySelectorAll(SELECTORS.appTable);
    const tiers = [];
    rows.forEach((tr) => {
      const qtyEl = tr.querySelector(SELECTORS.qty) || tr.querySelector('td:nth-child(1)');
      const discEl = tr.querySelector(SELECTORS.discount) || tr.querySelector('td:nth-child(2)');
      if (!qtyEl || !discEl) return;
      const minQty = parseInt(qtyEl.textContent.trim(), 10);
      if (Number.isNaN(minQty) || minQty < 1) return;
      const discountCents = parseEuMoneyToCents(discEl.textContent);
      tiers.push({ minQty, discountCents });
    });
    tiers.sort((a, b) => a.minQty - b.minQty);
    return tiers;
  }

  function buildRowsHtml(basePriceCents, tiers, unitLabel) {
    const rows = [];

    if (tiers[0].minQty > 1) {
      const hi = tiers[0].minQty - 1;
      rows.push({
        label: '1-' + hi + ' ' + unitLabel,
        cents: basePriceCents,
      });
    }

    for (let i = 0; i < tiers.length; i++) {
      const t = tiers[i];
      const next = tiers[i + 1];
      const finalCents = Math.max(0, basePriceCents - t.discountCents);
      let label;
      if (next) {
        label = t.minQty + '-' + (next.minQty - 1) + ' ' + unitLabel;
      } else {
        label = 'ab ' + t.minQty + ' ' + unitLabel;
      }
      rows.push({ label, cents: finalCents });
    }

    return rows
      .map(
        (r) =>
          '<tr data-tier-cents="' +
          r.cents +
          '"><td><b>' +
          escapeHtml(r.label) +
          '</b></td><td><b>' +
          formatMoneyCents(r.cents) +
          '</b></td></tr>'
      )
      .join('');
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function updateBlock(blockRoot) {
    const sectionId = blockRoot.getAttribute('data-section-id');
    if (!sectionId) return;
    const unitLabel = blockRoot.getAttribute('data-unit-label') || 'Stück';
    const tbody = blockRoot.querySelector('[data-bulk-price-rows]');
    if (!tbody) return;

    const variantPrices = getVariantPricesFromBlock(blockRoot);
    const basePriceCents = getBasePriceCents(sectionId, variantPrices);
    const tiers = parseAppTiers();

    if (!tiers.length || !basePriceCents || basePriceCents <= 0) {
      tbody.innerHTML = '';
      blockRoot.classList.add('hidden');
      return;
    }

    tbody.innerHTML = buildRowsHtml(basePriceCents, tiers, unitLabel);
    blockRoot.classList.remove('hidden');
    refreshAllTierPrices();
  }

  function initBlock(blockRoot) {
    if (blockRoot.dataset.bulkPriceInit) return;
    blockRoot.dataset.bulkPriceInit = '1';

    const tryUpdate = () => {
      const tiers = parseAppTiers();
      if (tiers.length === 0) return false;
      updateBlock(blockRoot);
      return true;
    };

    if (tryUpdate()) return;

    const obs = new MutationObserver(() => {
      if (tryUpdate()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    let n = 0;
    const poll = window.setInterval(() => {
      n += 1;
      if (tryUpdate() || n > 40) {
        window.clearInterval(poll);
        obs.disconnect();
        if (n > 40 && parseAppTiers().length === 0) {
          const tbody = blockRoot.querySelector('[data-bulk-price-rows]');
          if (tbody) tbody.innerHTML = '';
          blockRoot.classList.add('hidden');
        }
      }
    }, 500);
  }

  function initAll() {
    document.querySelectorAll('[data-bulk-price-table-root]').forEach((root) => initBlock(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const variantChangeEvent = 'variant-change';
  if (typeof subscribe === 'function' && !window.__bulkDiscountPriceVariantSubscribed) {
    window.__bulkDiscountPriceVariantSubscribed = true;
    subscribe(variantChangeEvent, () => {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('[data-bulk-price-table-root]').forEach((root) => updateBlock(root));
        document.querySelectorAll('script[data-tier-price-variants]').forEach((s) => {
          const sid = s.getAttribute('data-tier-price-variants');
          if (sid) updateProductTierPrice(sid);
        });
      });
    });
  }

  /* --- PDP: Hauptpreis + Grundpreis nach Warenkorb + Mengenfeld (App-Staffeln) --- */

  function getVariantTierConfig(sectionId) {
    const el = document.querySelector('script[data-tier-price-variants="' + sectionId + '"]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVariantFromTierConfig(cfg, variantId) {
    if (!cfg || !Array.isArray(cfg.variants)) return null;
    return cfg.variants.find((v) => String(v.id) === String(variantId));
  }

  function discountForQuantity(tiers, qty) {
    let discount = 0;
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].minQty) {
        discount = tiers[i].discountCents;
        break;
      }
    }
    return discount;
  }

  function getCheapestUnitPriceCents(basePriceCents, tiers) {
    let cheapest = null;

    document.querySelectorAll('[data-bulk-price-rows] tr[data-tier-cents]').forEach((tr) => {
      const cents = parseInt(tr.getAttribute('data-tier-cents'), 10);
      if (!Number.isNaN(cents) && cents >= 0 && (cheapest == null || cents < cheapest)) {
        cheapest = cents;
      }
    });
    if (cheapest != null) return cheapest;

    if (tiers && tiers.length) {
      cheapest = basePriceCents;
      for (let i = 0; i < tiers.length; i++) {
        const finalCents = Math.max(0, basePriceCents - tiers[i].discountCents);
        if (finalCents < cheapest) cheapest = finalCents;
      }
      return cheapest;
    }

    return basePriceCents;
  }

  function hasBuiltTierTable() {
    return !!document.querySelector('[data-bulk-price-rows] tr[data-tier-cents]');
  }

  function wrapFromPrice(priceRoot, formatted) {
    const tpl = (priceRoot && (priceRoot.getAttribute('data-from-price-html') || priceRoot.dataset.fromPriceHtml)) || '';
    if (tpl && tpl.indexOf('%%PRICE%%') !== -1) return tpl.replace('%%PRICE%%', formatted);
    return formatted;
  }

  function ensureStrikeEl(priceWrap) {
    let strikeEl = priceWrap.querySelector('.price__sale s.price-item--regular');
    if (strikeEl) return strikeEl;
    const saleBox = priceWrap.querySelector('.price__sale');
    if (!saleBox) return null;
    const holder = document.createElement('span');
    strikeEl = document.createElement('s');
    strikeEl.className = 'price-item price-item--regular';
    holder.appendChild(strikeEl);
    saleBox.appendChild(holder);
    return strikeEl;
  }

  function setDisplayedPriceText(priceWrap, currentText, strikeText, showSale, keepRegularVisible) {
    const saleEl = priceWrap.querySelector('.price__sale .price-item--sale');
    const regularBox = priceWrap.querySelector('.price__regular');
    const regEl = regularBox && regularBox.querySelector('.price-item--regular:not(s)');

    if (regEl) regEl.textContent = currentText;
    if (saleEl) saleEl.textContent = currentText;

    let inlineStrike = regularBox && regularBox.querySelector('s.price-item--tier-compare');
    if (keepRegularVisible && showSale && strikeText && regularBox) {
      if (!inlineStrike) {
        inlineStrike = document.createElement('s');
        inlineStrike.className = 'price-item price-item--tier-compare';
        regularBox.appendChild(inlineStrike);
      }
      inlineStrike.textContent = strikeText;
    } else if (inlineStrike) {
      inlineStrike.remove();
    }

    if (!keepRegularVisible && showSale && strikeText) {
      const strikeEl = ensureStrikeEl(priceWrap);
      if (strikeEl) strikeEl.textContent = strikeText;
    }

    priceWrap.classList.toggle('price--tier-discount', !!(keepRegularVisible && showSale));
    priceWrap.classList.toggle('price--on-sale', !!(!keepRegularVisible && showSale));

    priceWrap.setAttribute('data-tier-payable', currentText);
    guardPayablePrice(priceWrap, currentText, keepRegularVisible);
  }

  function guardPayablePrice(priceWrap, currentText, keepRegularVisible) {
    if (priceWrap._tierPayableGuard) {
      priceWrap._tierPayableGuard.disconnect();
      priceWrap._tierPayableGuard = null;
    }
    if (!keepRegularVisible) return;

    const apply = () => {
      const regularBox = priceWrap.querySelector('.price__regular');
      const regEl = regularBox && regularBox.querySelector('.price-item--regular:not(s)');
      const saleEl = priceWrap.querySelector('.price__sale .price-item--sale');
      if (regEl && regEl.textContent !== currentText) regEl.textContent = currentText;
      if (saleEl && saleEl.textContent !== currentText) saleEl.textContent = currentText;
    };

    const obs = new MutationObserver(() => {
      obs.disconnect();
      apply();
      obs.observe(priceWrap, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(priceWrap, { childList: true, subtree: true, characterData: true });
    priceWrap._tierPayableGuard = obs;
  }

  function isSoldOutButton(submitButton) {
    if (!submitButton) return false;
    const text = ((submitButton.querySelector('span') && submitButton.querySelector('span').textContent) || '').trim();
    const strings = window.variantStrings || {};
    return text === strings.soldOut || text === strings.unavailable;
  }

  function syncZeroQtyAddToCart(submitButton, qty) {
    if (!submitButton) return;
    if (isSoldOutButton(submitButton)) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
      return;
    }
    if (qty < 1) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('data-from-price-qty-disabled', 'true');
      return;
    }
    if (submitButton.getAttribute('data-from-price-qty-disabled') === 'true') {
      submitButton.removeAttribute('data-from-price-qty-disabled');
      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('aria-disabled');
    }
  }

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function renderTierPriceOnRoot(priceRoot, sectionId, qtyInput) {
    const cfg = getVariantTierConfig(sectionId);
    if (!priceRoot) return;

    const showLineTotal = priceRoot.dataset.showLineTotal === 'true';
    const showFromPrice = priceRoot.dataset.showFromPrice === 'true';
    if (!cfg || !Array.isArray(cfg.variants)) return;
    if (!showLineTotal && !showFromPrice && cfg.priceVaries) return;

    const tiers = parseAppTiers();
    if (!tiers.length && !showLineTotal && !showFromPrice) return;

    const variantId = getCurrentVariantId(sectionId);
    const v = getVariantFromTierConfig(cfg, variantId);
    if (!v || !v.price) return;

    const cartQty = qtyInput ? parseInt(qtyInput.getAttribute('data-cart-quantity') || '0', 10) : 0;
    const inputQty = qtyInput ? parseInt(String(qtyInput.value || '0'), 10) : 0;
    const safeInput = Number.isNaN(inputQty) ? 0 : Math.max(0, inputQty);
    const isFromPriceIdle = showFromPrice && safeInput <= 0;
    const totalQty = Math.max(1, cartQty + safeInput);

    let effective = v.price;
    if (isFromPriceIdle) {
      if (!tiers.length && !hasBuiltTierTable()) return;
      effective = getCheapestUnitPriceCents(v.price, tiers);
    } else if (tiers.length) {
      effective = Math.max(0, v.price - discountForQuantity(tiers, totalQty));
    }

    const priceWrap = priceRoot.querySelector('.price');
    if (!priceWrap) return;

    const originalUnit =
      v.compare_at_price > v.price ? v.compare_at_price : v.price;
    const hasDiscount = !isFromPriceIdle && effective < v.price;
    const hasShopifySale = v.compare_at_price > v.price;
    const showSale = !isFromPriceIdle && (hasDiscount || hasShopifySale);

    let currentCents = effective;
    let strikeCents = originalUnit;
    if (!isFromPriceIdle && showLineTotal) {
      currentCents = effective * totalQty;
      strikeCents = originalUnit * totalQty;
    }

    let formatted = formatMoneyCents(currentCents);
    if (isFromPriceIdle) formatted = wrapFromPrice(priceRoot, formatted);
    const strikeText =
      showSale && strikeCents > currentCents ? formatMoneyCents(strikeCents) : '';
    const keepRegularVisible = !isFromPriceIdle && showLineTotal && showSale;

    setDisplayedPriceText(priceWrap, formatted, strikeText, showSale, keepRegularVisible);

    if (v.unit_price != null && v.price > 0) {
      const unitCents = Math.round((v.unit_price * effective) / v.price);
      const unitMoney = formatMoneyCents(unitCents);
      const unitSpan = priceWrap.querySelector('.unit-price .price-item--last > span:first-child');
      if (unitSpan) unitSpan.textContent = unitMoney;
    }
  }

  function applyFromPriceToSticky(sectionId, showFromPrice) {
    const mainRoot = document.getElementById('price-' + sectionId);
    document.querySelectorAll('sticky-add-to-cart').forEach((sticky) => {
      const stickyQty = sticky.querySelector('.quantity-input');
      const stickyPrice = sticky.querySelector('[id^="price-"]');
      const stickySubmit = sticky.querySelector('.product-form__submit, [name="add"]');

      if (showFromPrice && stickyQty) {
        stickyQty.min = '0';
        stickyQty.setAttribute('data-min', '0');
        stickyQty.setAttribute('data-allow-zero', 'true');
        const current = parseInt(String(stickyQty.value || '0'), 10);
        if (Number.isNaN(current) || current < 1) stickyQty.value = '0';
      }

      if (stickyPrice && mainRoot) {
        stickyPrice.dataset.showFromPrice = mainRoot.dataset.showFromPrice || '';
        stickyPrice.dataset.showLineTotal = mainRoot.dataset.showLineTotal || '';
        stickyPrice.dataset.fromPriceHtml = mainRoot.getAttribute('data-from-price-html') || '';
        renderTierPriceOnRoot(stickyPrice, sectionId, stickyQty);
      }

      if (showFromPrice && stickySubmit && stickyQty) {
        const qty = parseInt(String(stickyQty.value || '0'), 10) || 0;
        syncZeroQtyAddToCart(stickySubmit, qty);
      }
    });
  }

  function updateProductTierPrice(sectionId) {
    const priceRoot = document.getElementById('price-' + sectionId);
    if (!priceRoot) return;

    const showFromPrice = priceRoot.dataset.showFromPrice === 'true';
    const qtyInput = document.getElementById('Quantity-' + sectionId);
    renderTierPriceOnRoot(priceRoot, sectionId, qtyInput);

    if (showFromPrice) {
      const form = document.getElementById('product-form-' + sectionId);
      const submit = form && form.querySelector('.product-form__submit, [name="add"]');
      const qty = qtyInput ? parseInt(String(qtyInput.value || '0'), 10) : 0;
      const safeQty = Number.isNaN(qty) ? 0 : qty;
      syncZeroQtyAddToCart(submit, safeQty);
    }

    applyFromPriceToSticky(sectionId, showFromPrice);
  }

  function refreshAllTierPrices() {
    document.querySelectorAll('script[data-tier-price-variants]').forEach((s) => {
      const sid = s.getAttribute('data-tier-price-variants');
      if (sid) updateProductTierPrice(sid);
    });
  }

  if (typeof subscribe === 'function' && !window.__tierPricePubSubInit) {
    window.__tierPricePubSubInit = true;
    subscribe('cart-update', () => {
      window.setTimeout(refreshAllTierPrices, 120);
    });
    subscribe('quantity-update', () => {
      window.requestAnimationFrame(refreshAllTierPrices);
    });
  }

  function initTierPricePanel(sectionId) {
    const cfg = getVariantTierConfig(sectionId);

    const priceRoot = document.getElementById('price-' + sectionId);
    if (!priceRoot || !priceRoot.hasAttribute('data-tier-price-root')) return;
    if (priceRoot.dataset.tierPricePanelInit) return;

    const showLineTotal = priceRoot.dataset.showLineTotal === 'true';
    const showFromPrice = priceRoot.dataset.showFromPrice === 'true';
    if (!cfg) return;
    if (!showLineTotal && !showFromPrice && cfg.priceVaries) return;

    priceRoot.dataset.tierPricePanelInit = '1';

    const run = () => updateProductTierPrice(sectionId);
    const debounced = debounce(run, 90);

    const qtyInput = document.getElementById('Quantity-' + sectionId);
    qtyInput?.addEventListener('input', debounced);
    qtyInput?.addEventListener('change', run);

    document.querySelectorAll('sticky-add-to-cart .quantity-input').forEach((input) => {
      if (input.dataset.tierPriceBound) return;
      input.dataset.tierPriceBound = '1';
      if (showFromPrice) {
        input.min = '0';
        input.setAttribute('data-min', '0');
        input.setAttribute('data-allow-zero', 'true');
        const current = parseInt(String(input.value || '0'), 10);
        if (Number.isNaN(current) || current < 1) input.value = '0';
      }
      input.addEventListener('input', debounced);
      input.addEventListener('change', run);
    });

    const tableReady = () => hasBuiltTierTable() || parseAppTiers().some((t) => t.discountCents > 0);

    let tiersObs = new MutationObserver(() => {
      if (tableReady()) {
        run();
        if (hasBuiltTierTable()) tiersObs.disconnect();
      }
    });
    tiersObs.observe(document.documentElement, { childList: true, subtree: true });

    let n = 0;
    const poll = window.setInterval(() => {
      n += 1;
      if (tableReady()) {
        run();
        if (hasBuiltTierTable() || n > 45) {
          window.clearInterval(poll);
          tiersObs.disconnect();
        }
      } else if (n > 45) {
        window.clearInterval(poll);
        tiersObs.disconnect();
        if (showFromPrice) run();
      }
    }, 350);

    run();
  }

  function initAllTierPricePanels() {
    document.querySelectorAll('script[data-tier-price-variants]').forEach((script) => {
      const sectionId = script.getAttribute('data-tier-price-variants');
      if (sectionId) initTierPricePanel(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTierPricePanels);
  } else {
    initAllTierPricePanels();
  }
})();
